import './style.css';

function Container({ children }) {
  return <div className="container-component">{children}</div>;
}

export default Container;
